import { Outlet } from "react-router-dom";
import { AuthorizedGate } from "../authz/AuthorizedGate";
import { TopBar } from "../chrome/TopBar";
import { Sidebar } from "../chrome/Sidebar";
import { IdentityGate } from "../identity/IdentityGate";
import { ProjectGate } from "../project/ProjectGate";
import { ProjectSwitchModal } from "../project/ProjectSwitchModal";

/**
 * Root shell — matches the prototype's three-region layout
 * (`requirements/ui-patterns.md`):
 *
 * ┌─────────┬──────────────────────────────────────────────┐
 * │ sidebar │ top-bar  (chrome: org / project / jobs / auth) │
 * │ 60px    │ ──────────────────────────────────────────── │
 * │ navy    │              main content                      │
 * │         │              (overflow-y, --n1 background)     │
 * └─────────┴──────────────────────────────────────────────┘
 *
 * The Identity + Project gates wrap only the main region so the
 * Authorize button, org indicator, and project indicator stay reachable
 * across all states (including pre-auth). `<ProjectSwitchModal/>` is a
 * sibling so it overlays anything below.
 */
export function RootLayout() {
    return (
        <div className="app-shell">
            <Sidebar />
            <div className="app-body">
                <TopBar />
                <main className="app-main">
                    {/* PRD-005 ADR §7: AuthorizedGate sits OUTSIDE IdentityGate so
                        a missing-Subject_Read JWT lands on the deny page before
                        /auth/identity's 403 surfaces as a generic Retry banner. */}
                    <AuthorizedGate>
                        <IdentityGate>
                            <ProjectGate>
                                <Outlet />
                            </ProjectGate>
                        </IdentityGate>
                    </AuthorizedGate>
                </main>
            </div>
            <ProjectSwitchModal />
        </div>
    );
}
